import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de la date d'accouchement";
const DESCRIPTION =
  "Calculatrice de la date d pour obtenir des estimations utiles en sante feminine et suivi du cycle. Entrez vos informations et recevez des resultats rapides pour mieux planifier.";
const KEYWORDS =
  "de la date d, calculatrice de la date d, calcul en ligne, sante feminine, cycle, grossesse, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/due-date-calculator/";
function DueDateCalculator() {
  const [lastPeriod, setLastPeriod] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!lastPeriod) {
        setError("Veuillez entrer la date des dernières règles");
        setResult(null);
        return;
      }
      const date = new Date(lastPeriod);
      if (isNaN(date)) {
        setError("Date invalide");
        setResult(null);
        return;
      }
      const dueDate = new Date(date);
      dueDate.setDate(dueDate.getDate() + 280);
      const today = new Date();
      const weeksPregnant = Math.floor((today - date) / (7 * 24 * 60 * 60 * 1000));
      const weeksRemaining = Math.floor((dueDate - today) / (7 * 24 * 60 * 60 * 1000));
      setResult({
        dueDate: dueDate.toLocaleDateString("fr-FR"),
        weeksPregnant: weeksPregnant,
        weeksRemaining: weeksRemaining,
        daysRemaining: Math.floor((dueDate - today) / (24 * 60 * 60 * 1000))
      });
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de date d'accouchement estime la date probable de naissance
                  en fonction de la date des dernières règles. La grossesse dure généralement
                  280 jours (40 semaines) à partir du premier jour des dernières règles.
                </p>
                <p><strong>Avertissement médical:</strong> Cette calculatrice est fournie à titre indicatif uniquement.
                Consultez un healthcare professionnel pour une évaluation médicale.</p>
                <ul>
                  <li>Calcul basé sur 280 jours de grossesse</li>
                  <li>Affiche les semaines et jours restants</li>
                  <li>À titre informatif uniquement</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Date des dernières règles
                      </label>
                      <input
                        type="date"
                        value={lastPeriod}
                        onChange={(e) => setLastPeriod(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>Date d'accouchement estimée: <strong>{result.dueDate}</strong></p>
                      <p>Semaines de grossesse actuelle: <strong>{result.weeksPregnant}</strong></p>
                      <p>Semaines restantes: <strong>{result.weeksRemaining}</strong></p>
                      <p>Jours restants: <strong>{result.daysRemaining}</strong></p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Estimation de la date d'accouchement</strong>
              </div>
              <div className="info-section-body">
                <p>
                  La date d'accouchement estimée, également connue sous le nom de date de naissance estimée, est une estimation du moment où une femme enceinte accouchera. Bien que la date d'accouchement soit généralement estimée comme une seule date, il est utile de considérer une plage de dates d'accouchement, car seulement 4% des naissances se produisent à la date d'accouchement estimée.
                </p>
                <p>
                  Les dates d'accouchement peuvent être estimées à l'aide de plusieurs méthodes différentes, notamment les dernières règles (DDR), l'échographie, la date de conception et la date de transfert d'embryon congelé (FIV).
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Les dernières règles (DDR)</strong>
              </div>
              <div className="info-section-body">
                <p>
                  La méthode par défaut de cette calculatrice est basée sur les dernières règles (DDR) de la femme, en supposant que la grossesse dure en moyenne 280 jours ou 40 semaines. Bien qu'il y ait une certaine controverse sur le moment précis où la grossesse commence, l'âge gestationnel ne change pas car il est basé sur la DDR. En termes d'âge gestationnel, les grossesses durent généralement entre 37 et 42 semaines, avec 40 semaines comme estimation standard pour les calculs.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>La date d'accouchement comme point de référence</strong>
              </div>
              <div className="info-section-body">
                <p>
                  En général, un accouchement entre 37 et 42 semaines n'est pas une cause d'inquiétude. Les bébés nés entre les semaines 37-39, 39-41 et 41-42 sont considérés respectivement comme prématurés, nés à terme et en retard. Dans des conditions naturelles, les bébés nés pendant l'une de ces périodes peuvent être en bonne santé, bien que les bébés nés à terme aient généralement de meilleurs résultats.
                </p>
                <p>
                  Les bébés nés avant la semaine 37 sont considérés comme prématurés, tandis que ceux nés après la semaine 42 sont considérés comme tardifs. Ces périodes sont importantes comme point de référence pour les médecins permettant de déterminer s'il y a besoin de toute intervention. Par exemple, si une femme entre en travail très tôt à la semaine 33, les médecins peuvent arrêter le travail pour éviter une naissance prématurée. À l'inverse, si une femme n'entre pas en travail après la semaine 42, les médecins peuvent induire l'accouchement.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Complications une fois passé la semaine 42</strong>
              </div>
              <div className="info-section-body">
                <p>
                  L'une des complications potentielles de laisser une grossesse se poursuivre après la semaine 42 est que le placenta, responsable de la fourniture des nutriments et de l'oxygène au bébé, peut cesser de fonctionner correctement, éventuellement avec le bébé qui continue de grandir et ayant besoin de plus de nutriments et d'oxygène, ce qui finira par mener à des complications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DueDateCalculator;
